<template>
    <v-layout align-start justify-start row wrap v-if="Object.keys(result).length">
        <v-flex d-flex xs12>
            <v-card>
                <v-card-text>
                    <p><b>{{result[attributes.displaytitle]}}</b>  </br> 
                        {{result[attributes.displaysubtitle]}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-icon class="mt-1" v-on:click.stop="remove(result)">
                        close
                    </v-icon>
                </v-card-actions>
            </v-card>                                                                                                                  
        </v-flex>
    </v-layout>
</template>
<script>
    export default {   
   
    props: [
        'result',
        'attributes'
    ],
    methods: {
        
        remove (item) {            
            this.result = []
        },              
    }    
    
}
</script>